import { useState, useCallback } from 'react';
import tokenUsageAPI from '../api/tokenUsageAPI';

const useTokenUsage = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const getSummary = useCallback(async (userRole) => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await tokenUsageAPI.getSummary(userRole);
      if (!response.success) setError(response.error);
      setIsLoading(false);
      return response;
    } catch (err) {
      setError(err.message);
      setIsLoading(false);
      throw err;
    }
  }, []);

  const getRecent = useCallback(async (limit) => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await tokenUsageAPI.getRecent(limit);
      if (!response.success) setError(response.error);
      setIsLoading(false);
      return response;
    } catch (err) {
      setError(err.message);
      setIsLoading(false);
      throw err;
    }
  }, []);

  const getAdminReport = useCallback(async (filters) => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await tokenUsageAPI.getAdminReport(filters);
      if (!response.success) setError(response.error);
      setIsLoading(false);
      return response;
    } catch (err) {
      setError(err.message);
      setIsLoading(false);
      throw err;
    }
  }, []);

  return { getSummary, getRecent, getAdminReport, isLoading, error };
};

export default useTokenUsage;